import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window')
const { height } = Dimensions.get('screen')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    sectionTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
        marginHorizontal: 12,
        marginTop: 12,
    },
    brand: {
        width: 120,
        height: 120,
        alignSelf: 'center',
    },
    brandProduct: {
        fontSize: 14,
        fontWeight: '500',
        color: theme.colors.textSecondary,
        marginTop: 12,
        marginHorizontal: 12,
    },
    nameProduct: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginHorizontal: 12,
        marginTop: 4,
        marginBottom: 8,
        textAlignVertical: 'top',
    },
    descriptionProduct: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginBottom: 10,
        marginHorizontal: 12,
    },
    containerDataProduct: {
        flexDirection: 'row',
        paddingHorizontal: 12,
    },
    dataProduct: {
        flex: 1,
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginBottom: 2,
    },
    dividerHorizontalLine: {
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        marginHorizontal: 12,
        marginVertical: 8,
    },
    containerItem: {
        marginHorizontal: 12,
        marginVertical: 10,
        flexDirection: 'row',
        alignItems: 'center',
        padding: 10,
        borderWidth: 1,
        borderColor: theme.colors.colorPrimary,
        borderRadius: 10,
        backgroundColor: 'white',
    },
    fileName: {
        flex: 1,
        fontSize: 14,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
    },
    icons: {
        flexDirection: 'row',
    },
    iconButton: {
        height: 24,
        width: 24,
        marginLeft: 10,
        tintColor: theme.colors.colorPrimary,
    },
    spacer: {
        marginBottom: 10,
    },
})
export default styles
